


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCyfHxGFjyFG1ygLz4ANh8mW0kEkMXvxBA",
  authDomain: "opex-eye-care.firebaseapp.com",
  projectId: "opex-eye-care",
  storageBucket: "opex-eye-care.firebasestorage.app",
  messagingSenderId: "680294079379",
  appId: "1:680294079379:web:6a7f422437dff4fdc06666"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export